import Elemento from './Elemento.js';

export default class Producto extends Elemento {
  constructor() {
    super();
    this.modeloSel = new String();
    this.modelos = new Array();
    this.getModelo = function (param) {
      var element = param == undefined ? (element = this.modeloSel) : param;

      var filter = this.modelos.find((modeloEl) => modeloEl.cod == element);

      return filter != undefined ? filter : this.modelos[0];
    };
    this.getModeloSel = function () {
      var filter = this.modelos.find(
        (modeloEl) => modeloEl.cod == this.modeloSel
      );
      return filter != undefined ? filter : this.modelos[0];
    };
  }
}
